export default function Start() {
  return (
    <section id="start" className="portfolio__start portfolio__elem">
      <h1 title="Leonardo de Souza Leal Figueira">
        <a href="./">Leonardo de S. Leal</a>
      </h1>
      <p className="start__description">
        Entusiasta del <strong>Frontend</strong>, enfocado
        en <strong>React</strong> y <strong>SASS</strong>.
      </p>
    </section>
  );
}

// TODO https://kizu.dev/fit-to-width-text/
